import { PolicyList } from "./PolicyList.tsx";
import { PolicyShow } from "./PolicyShow.tsx";
import { PolicyCreate } from "./PolicyCreate.tsx";
import { getResourceIcon } from "@/utils/icons.ts";
import { ResourceName } from "@/types";

const PolicyIcon = getResourceIcon(ResourceName.POLICIES);

const resource = {
  list: PolicyList,
  show: PolicyShow,
  //   edit: PolicyEdit,
  create: PolicyCreate,
  icon: PolicyIcon,
  recordRepresentation: (record: any) => `${record.name}`,
};

export default resource;
